import React from 'react';

const CheckboxCell = ({ selectedIndices, customer, onChange, accessor, formatter, disabled, idx }) => {
  const isChecked = selectedIndices[accessor] === idx;
  return (
    <div className="c-checkbox-secondary">
      <label className="c-checkbox-secondary__label">
        <input
          type="checkbox"
          className="c-checkbox-secondary__input c-checkbox-secondary__input-disabled-opacity"
          data-accessor={accessor}
          data-value={customer[accessor]}
          data-idx={idx}
          onChange={onChange}
          disabled={disabled}
          checked={isChecked}
        />
        <span className="c-checkbox-secondary__trigger" />
        <span className="c-checkbox-secondary__text">
          {formatter(customer[accessor], customer)}
        </span>
      </label>
    </div>
  );
};

CheckboxCell.defaultProps = {
  formatter: value => value,
};

export default CheckboxCell;
